const filterCompanyPages = (urls) => {
    const companyKeywords = [
        "about", "our-story", "our-company", "who-we-are", "contact", "products",
        "services", "solutions", "what-we-do", "offerings", "blog", "news",
        "resources", "insights", "faq", "help", "pricing", "plans", "privacy",
        "terms-and-conditions", "terms-of-use", "case-studies", "projects",
        "portfolio", "testimonials", "reviews",
    ];
    //  Filter URLs based on keywords
    const matched = urls.filter((url) =>
        companyKeywords.some((keyword) =>
            url.toLowerCase().includes(keyword.toLowerCase())
        )
    );
    
    //  100 limit logic remove  
    // Final list should show ALL matching + ALL other URLs
    const remaining = urls.filter((url) => !matched.includes(url));
    const finalList = [...matched, ...remaining];  //  No limit here

    //  First 10 new URLs converted into object format
    const first10 = finalList.slice(0, 10).map((url) => ({
        url,
        checkedStatus: true,
    }));
    //  Save unique URLs (only first 10)
    const unique = [];
    const urlSet = new Set();

    first10.forEach((item) => {
        if (!urlSet.has(item.url)) {
            urlSet.add(item.url);
            unique.push(item);
        }
    });
    sessionStorage.setItem("refreshSelectedSiteMapUrls", JSON.stringify(unique))
    sessionStorage.setItem("selectedSiteMapUrls", JSON.stringify(unique));

    return finalList; //  Return all URLs now
};

export default filterCompanyPages;
